import React from "react";
import styled from "styled-components";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import { ButtonProps } from "@sonder/ui/source/styled/fragments/Button";
import { CircleButton } from "@sonder/ui/source/styled/fragments/CircleButton";
import { colors } from "@sonder/ui/source/styled/theme";

interface ChecklistItemToggleProps extends ButtonProps {
  isChecked?: boolean;
}

const StyledCircleButton = styled(CircleButton)<ChecklistItemToggleProps>`
  color: ${props => (props.selected ? colors.blue7 : "inherit")};
  margin-right: 0.75rem;
`;

export const ChecklistItemToggle = ({
  disabled,
  isChecked,
  onClick,
}: ChecklistItemToggleProps) => (
  <StyledCircleButton
    backgroundVariant="light"
    disabled={disabled}
    selected={isChecked}
    title={isChecked ? "Uncheck this item" : "Check this item"}
    onClick={onClick}
  >
    {isChecked ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
  </StyledCircleButton>
);
